module.exports = __webpack_public_path__ + "static/media/ihl-logo.b01a769b.svg";